var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18734 22H1.81306C1.59743 22 1.39062 21.9145 1.23814 21.7622C1.08566 21.61 1 21.4035 1 21.1882V16.8207C1.02138 16.0998 1.31809 15.4143 1.82932 14.9048L14.9684 1.78603C15.4251 1.30459 16.0537 1.02258 16.7175 1.0013C17.3813 0.980016 18.0267 1.22118 18.5134 1.67238L21.3266 4.48123C21.7785 4.96717 22.02 5.61156 21.9987 6.27434C21.9774 6.93711 21.6949 7.5647 21.2127 8.0207L8.10617 21.0908C7.60908 21.6311 6.92094 21.9572 6.18734 22Z",
    stroke: "#303030",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3516 4.36755L18.6121 10.6185",
    stroke: "#303030",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2852 21.9514H19.2938",
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.8d976524350c902ec708708fd8b95eef.svg";
export { ForwardRef as ReactComponent };